

class StickyHeader extends HTMLElement {
  constructor() {
    super();

    // COMPONENT STATE
    this._sticky = false;
    this._isMenuOpen = false;
    this._isCartOpen = false;
    this._isSearchOpen = false;
    this._isLocaleDrawerOpen = false;
    this.selectedMenu = null;
    this._headerHeight = this.offsetHeight;
    this._scrollY = window.scrollY;

    // COMPONENT ELEMENTS
    this.stickyHeader = this.querySelector("#sticky-header");
    this.headerContainer = this.querySelector("#header-container");
    this.headerLogo = this.querySelector("#header-logo");
    this.burgerMenu = document.querySelector("#burger-menu");
    this.menuDesktop = document.querySelector("#menu-desktop");
    this.cartMenuDesktop = document.querySelector("#cartMenu-desktop");
    this.cartIcon = document.querySelector("#cart-icon");
    this.searchIcon = document.querySelector("#search-icon");
    this.menuNav = document.querySelector("#menu-nav");
    this.searchModal = document.querySelector("#search-modal");
    this.locationDrawer = document.querySelector("#location-drawer");
    this.iconsContainer = document.querySelector("#icons-container");
    this.menuCart = document.querySelector("#menu-cart");
    this.overlay = document.querySelector("#overlay");
    this.closeMenuButton = document.querySelector("#close-menu-button");
    this.menuItems = document.querySelectorAll(".menu-item");
    this.menuItemsDesktop = document.querySelectorAll(".menu-item-desktop");
    this.menuListItems = document.querySelectorAll(".menu-item_list_item");
    this.subMenuItems = document.querySelectorAll(".sub-menu-item_list");
    this.subMenuItemsDesktop = document.querySelectorAll(
      ".sub-menu-item_list--desktop"
    );
    this.thirdLevelMenuItems = document.querySelectorAll(".third-level-menu");
    this.desktopMenuLists = document.querySelectorAll(
      ".menu-item_list--desktop"
    );
    this.headerBannerContainer = document.querySelector("[header-banner]");
    this.clientCareLink = document.querySelectorAll("[client-care-link]");
    this.localizationChangeLink = document.querySelectorAll(
      "[localization-change-link]"
    );

    // Step 1: get the elements to observe | TODO: remove
    // this.headerTriggerElements = document.querySelectorAll(".observer-element");

    this.main = document.querySelector("#MainContent");
    this.mainClass = "js-main-padding";

    // BINDINGS | EVENT LISTENERS
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener("cartUpdated", () => {
      this.openCart();
    });
    document.addEventListener("close-search", (e) => {
      if (e.detail.force) {
        this.closeSearch();
      }
    });
    document.addEventListener("scroll", () => {
      if (((window.scrollY > this._scrollY - 100)) && this._isSearchOpen) {
        this.closeSearch();
      }
    });
    document.body.addEventListener("click", (e) => {
      this.checkMenuDrawerClose(e);
      this.checkCartDrawerClose(e);
      this.checkSearchDrawerClose(e);
      this.checkLocaleDrawerClose(e);
    });
    this.menuItems.forEach((item) => {
      let isHovering = false;
      item.addEventListener("mouseover", (e) => {
        isHovering = true;
        setTimeout(() => {
          if (isHovering) {
            this.selectMenu(item);
            this.deselectAllSubMenuItems();
            this.changeBanner(item);
          }
        }, 100);
      });
      item.addEventListener("mouseout", () => {
        isHovering = false;
      });
    });
    this.menuListItems.forEach((item) => {
      let isHovering = false;
      item.addEventListener("mouseover", (e) => {
        isHovering = true;
        setTimeout(() => {
          if (isHovering) {
            this.deselectAllSubMenuItems();
            this.selectSubMenu(item.closest(".menu-item_list_item"));
          }
        }, 100);
      });
      item.addEventListener("mouseout", () => {
        isHovering = false;
      });
    });
    // this.menuItemsDesktop.forEach((item) => {
    //   let isHovering = false;
    //   let menuId = item.getAttribute("data-menu-id");
    //   item.addEventListener("mouseover", (e) => {
    //     isHovering = true;
    //     setTimeout(() => {
    //       if (isHovering) {
    //         this.deselectAllSubMenuItems();
    //         this.openMenu(menuId - 1);
    //       }
    //     }, 100);
    //   });
    //   item.addEventListener("mouseout", () => {
    //     isHovering = false;
    //   });
    // });
    // document.addEventListener("scroll", (e) => {
    //   if (this._isSearchOpen) this.closeSearch();
    // });
    this.clientCareLink.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        this.clickCareLink();
      });
    });

    this.addEventListener("click", (e) => {
      if (e.target.id == "header-container") {
        window.location.href =
          document.querySelector("[main-banner]").dataset.bannerLink;
      }
    });
    this.searchModal.querySelector("form").addEventListener("submit", (e) => {
      e.preventDefault();
      if (e.target.querySelector("input").value.toLowerCase() == "sale") {
        window.location.href = "/pages/annual-archive-sale-sign-up";
      } else if (
        e.target.querySelector("input").value.toLowerCase() == "zegna"
      ) {
        window.location.href = "/pages/zegna-x-tes-the-oasi-of-cashmere";
      } else {
        this.searchModal.querySelector("form").submit();
      }
    });
  }

  isParent(refNode, otherNode) {
    var parent = otherNode.parentNode;
    do {
      if (refNode == parent) {
        return true;
      } else {
        parent = parent.parentNode;
      }
    } while (parent);
    return false;
  }

  clickCareLink() {
    let date = new Date();
    let localTime = date.getTime();
    let localOffset = date.getTimezoneOffset() * 60000;
    let utc = localTime + localOffset;
    let PstOffset = -8;
    let pst = utc + 3600000 * PstOffset;
    let pstDate = new Date(pst);
    let hours = pstDate.getHours();
    let minutes = pstDate.getMinutes();
    let weekday = pstDate.getDay();
    let isWeekday = weekday >= 1 && weekday <= 5;
    let isAfterHours = hours >= 17 && minutes >= 1;
    let isBeforeHours = hours <= 8 && minutes <= 59;
    if (isWeekday && !isAfterHours && !isBeforeHours) {
      GorgiasChat.isOpen() ? GorgiasChat.close() : GorgiasChat.open();
    } else {
      window.location = "/pages/contact-us";
    }
  }

  getScrollBarWidth() {
    // Creating invisible container
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll"; // forcing scrollbar to appear
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement("div");
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
  }

  addBodyOverflow(direction) {
    let scrollbarWidth = this.getScrollBarWidth();
    const lockPadding = document.querySelectorAll(".js-lock-padding");

    if (lockPadding.length > 0) {
      for (let index = 0; index < lockPadding.length; index++) {
        const el = lockPadding[index];
        el.style.paddingRight = scrollbarWidth + "px";
      }
    }
    document.body.classList.add("body-overflow");
    // document.querySelector('sticky-header').style.paddingRight = scrollbarWidth + 'px';
    document.body.style.paddingRight = scrollbarWidth + "px";
    window.addEventListener("scroll", (e) => {
      e.preventDefault();
    });
  }

  removeBodyOverflow(direction) {
    setTimeout(() => {
      const lockPadding = document.querySelectorAll(".js-lock-padding");
      if (lockPadding.length > 0) {
        for (let index = 0; index < lockPadding.length; index++) {
          const el = lockPadding[index];
          el.style.paddingRight = "0px";
        }
      }
      document.body.classList.remove("body-overflow");
      document.body.style.paddingRight = "0px";
      // document.querySelector('sticky-header').style.paddingRight = 64;

      window.addEventListener("scroll", (e) => {
        return true;
      });
    }, 0);
  }

  checkSticky() {
    if (
      window.scrollY >= this._headerHeight / 2 
      ||
      this.classList.contains("fixed-header")
    ) {
      if (this.getAttribute('data-collapsed_header') == 'true' && window.scrollY <= this._headerHeight / 2 && window.location.pathname == '/') {
        this.classList.remove("top-0")
      } else {
        this.classList.add("top-0")
      }
      this.classList.add("fixed", "h-max", "border-b", "border-black");
      this.classList.remove("absolute", "h-min", "lg:py-10");
      this.burgerMenu.classList.remove("lg:hidden");
      this.iconsContainer.classList.remove("lg:hidden");
      this.menuDesktop.classList.add("!hidden");
      this.cartMenuDesktop.classList.add("!hidden");
      this.headerContainer.classList.add("!items-center");
    } else {
      console.log('absolute')
      this.classList.remove("fixed", "h-max", "border-b", "border-black");
      this.classList.add("absolute", "h-min", "lg:py-10");
      this.burgerMenu.classList.add("lg:hidden");
      this.iconsContainer.classList.add("lg:hidden");
      this.menuDesktop.classList.remove("!hidden");
      this.cartMenuDesktop.classList.remove("!hidden");
      this.headerContainer.classList.remove("!items-center");
    }
  }

  changeBanner(link) {
    let bannerImage = link.dataset.bannerImage;
    let bannerTitle = link.dataset.bannerTitle;
    let bannerLinkLabel = link.dataset.bannerLinkLabel;
    let bannerLinkUrl = link.dataset.bannerLink;
    let bannerTextColor = link.dataset.bannerTextColor;

    if (
      bannerImage.includes("no-image") ||
      bannerTitle == undefined ||
      bannerLinkLabel == undefined
    )
      return;

    this.headerBannerContainer.classList.remove("invisible");
    this.headerBannerContainer.querySelector("img").src = bannerImage;
    this.headerBannerContainer.querySelector("h2").innerText = bannerTitle;
    this.headerBannerContainer.querySelector("h2").style.color =
      bannerTextColor;
    this.headerBannerContainer.querySelector("a").innerText = bannerLinkLabel;
    this.headerBannerContainer.querySelector("a").href = bannerLinkUrl;
    this.headerBannerContainer.querySelector("a").style.color = bannerTextColor;

    this.headerBannerContainer.addEventListener("click", (e) => {
      e.preventDefault();
      window.location.href = bannerLinkUrl;
    });
  }

  deselectAllMenuItems() {
    this.menuItems.forEach((item) => {
      let label = item.querySelectorAll(".menu-item_label");
      let list = item.querySelector(".menu-item_list");
      label.forEach((el) => {
        el.classList.remove("active");
      });
      list.classList.add("h-0");
      list.classList.remove("menu-item_list--opening");
      list.classList.remove("mb-10");
    });
    this.desktopMenuLists.forEach((list) => {
      list.classList.add("hidden");
    });
  }

  deselectAllSubMenuItems() {
    this.subMenuItemsDesktop.forEach((list) => {
      list.classList.add("hidden");
      let label = list.querySelectorAll(".menu-item_list_item_link");

      label.forEach((el) => {
        el.classList.remove("active");
      });

      let secondLevelList = document.querySelectorAll(
        ".menu-item_list_item_link"
      );

      secondLevelList.forEach((el) => {
        el.style.color = "";
        el.classList.remove("active");
      });
    });
  }

  selectMenu(item = this.menuItems[0]) {
    if (!item) return;
    this.deselectAllMenuItems();
    let menuId = item.getAttribute("data-menu-id");
    let label = item.querySelectorAll(".menu-item_label");
    let list = item.querySelector(".menu-item_list");

    this.desktopMenuLists.forEach((list) => {
      let id = list.getAttribute("data-menu-id");
      if (id === menuId) {
        list.classList.remove("hidden");
      }
    });
    label.forEach((el) => {
      el.classList.add("active");
    });
    list.classList.remove("h-0");
    list.classList.add("mb-10");
    list.classList.add("menu-item_list--opening");
  }

  selectSubMenu(item) {
    if (!item) return;
    this.deselectAllSubMenuItems();
    let subMenuId = item.getAttribute("data-sub-menu-id");

    let label = item.querySelectorAll(".menu-item_list_item_link");

    label.forEach((el) => {
      el.classList.add("active");
    });

    this.subMenuItemsDesktop.forEach((list) => {
      let id = list.getAttribute("data-sub-menu-id");
      if (id === subMenuId) {
        list.classList.remove("hidden");

        let secondLevelList = document.querySelectorAll(
          ".menu-item_list_item_link"
        );

        secondLevelList.forEach((el) => {
          if (el.classList.contains("active")) {
            return;
          } else {
            el.style.color = "#8E8E8E";
          }
        });
      }
    });
  }

  checkMenuDrawerClose(e) {
    if (!this._isMenuOpen) {
      if (e.target.closest("#burger-menu")) {
        this.openMenu();
      }
    } else {
      if (
        !e.target.closest("#menu-nav") ||
        e.target.closest("#close-menu-button")
      ) {
        this.closeMenu();
      }
    }
  }

  checkSearchDrawerClose(e) {
    if (!this._isSearchOpen) {
      if (
        e.target.closest("#search-icon") ||
        e.target.closest("#search-button")
      ) {
        this.openSearch();
        this._isMenuOpen ? this.closeMenu() : null;
      }
    } else {
      if (
        !e.target.closest("#search-modal") ||
        e.target.closest("#close-search-button")
      ) {
        this.closeSearch();
      }
    }
  }

  checkCartDrawerClose(e) {
    if (!this._isCartOpen) {
      if (e.target.closest("#cart-icon")) {
        this.openCart();
      }
    } else {
      if (
        !e.target.closest("#menu-cart") ||
        e.target.closest("#close-cart-button")
      ) {
        this.closeCart();
      }
    }
  }

  checkLocaleDrawerClose(e) {
    if (!this._isLocaleDrawerOpen) {
      if (e.target.closest("[localization-change-link]")) {
        this.openLocationModal();
      }
    } else {
      if (
        !e.target.closest("#location-drawer") ||
        e.target.closest("#close-locale-button")
      ) {
        this.closeLocationModal();
      }
    }
  }

  openSearch() {
    this._isSearchOpen = true;

    

    this.searchModal.classList.remove("hidden");
    setTimeout(() => {
      const stickyHeader = document.querySelector("sticky-header");
      stickyHeader.style.backgroundColor = '#fff';
      this.searchModal.classList.remove("-translate-y-[100%]");
      this.searchModal.classList.remove("opacity-0");
    }, 200);

    const input = this.searchModal.querySelector('input[type="search"]');
  
    setTimeout(() => {
      input?.focus();
    }, 200);
    // this.overlay.classList.toggle("invisible");
  }

  closeSearch() {
    this._isSearchOpen = false;

    const stickyHeader = document.querySelector("sticky-header");
    stickyHeader.style.backgroundColor = '';

    this.searchModal.classList.add("-translate-y-[100%]");
    this.searchModal.classList.add("opacity-0");

    setTimeout(() => {
      this.searchModal.classList.add("hidden");
    }, 200);
    // this.overlay.classList.toggle("invisible");
    
    // Collapse the keyboard
    const searchInput = this.searchModal.querySelector('input[type="search"]');
    if (searchInput) {
      searchInput.blur();
    }
  }

  openCart() {
    this._isCartOpen = true;
    this.menuCart.classList.add("transform", "!translate-x-0", "!visible");
    this.overlay.classList.remove("invisible");
    // document.body.classList.add('overflow-hidden');
    // this.addBodyOverflow();
  }

  closeCart() {
    this._isCartOpen = false;
    this.menuCart.classList.remove("transform", "!translate-x-0", "!visible");
    this.overlay.classList.toggle("invisible");
    document.body.classList.remove("overflow-hidden");
    // this.removeBodyOverflow();
  }

  openMenu(menuId) {
    this._isMenuOpen = true;
    this.menuNav.classList.add("transform", "!translate-x-0", "!visible");
    this.overlay.classList.toggle("invisible");
    menuId != "undefined"
      ? this.selectMenu(this.menuItems[menuId])
      : this.selectMenu();
  }

  closeMenu() {
    this._isMenuOpen = false;
    this.deselectAllMenuItems();
    this.menuNav.classList.remove("transform", "!translate-x-0", "!visible");
    this.overlay.classList.toggle("invisible");
    document.body.classList.remove("overflow-hidden");
  }

  openLocationModal() {
    this._isLocaleDrawerOpen = true;
    this.locationDrawer.classList.add(
      "transform",
      "!translate-x-0",
      "!visible"
    );
    this.overlay.classList.toggle("invisible");
  }

  closeLocationModal() {
    this._isLocaleDrawerOpen = false;
    this.locationDrawer.classList.remove(
      "transform",
      "!translate-x-0",
      "!visible"
    );
    this.overlay.classList.toggle("invisible");
    document.body.classList.remove("overflow-hidden");
  }

  addMainPadding() {
    console.log('addMainPadding', this.main.classList.contains(this.mainClass));
    this.main.classList.contains(this.mainClass)
      ? (this.main.style.paddingTop = this.offsetHeight + "px")
      : false;

    this.classList.contains(this.mainClass)
      ? (this.main.style.paddingTop = this.offsetHeight + "px")
      : false;
  }
}

customElements.define("sticky-header", StickyHeader);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // COMPONENT ELEMENTS
    this.deleteButtons = this.querySelectorAll("[delete-button]");
    this.giftButtons = this.querySelectorAll("[gift-input]");
    this.closePackageModalButtons = this.querySelectorAll(
      "[close-package-modal-button]"
    );
    this.openPackageModalButtons = this.querySelectorAll(
      "[gift-modal-trigger]"
    );
    this.itemsContainer = this.querySelector(".cart-items");
    this.summaryContainer = this.querySelector(".cart-summary");
    this.cartCount = this.querySelector("#cart-count");
    this.cartCountHeader = document.querySelector("#icons-container #cart-count");
    this.packageModal = this.querySelector("[package-modal]");

    // COMPONENT STATE
    this.vipClient = this.dataset.vip.includes("vip-client") ? true : false;

    // BIND METHODS
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        this.checkGiftFee(cart);
      });
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener("cartUpdated", () => {
      this.updateCart();
    });
    this.deleteButtons.forEach((button, index) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        let key = button.dataset.key;
        let variantId = button.dataset.variant;
        let customize = button.dataset.customize;
        let quantity = button.dataset.quantity;
        let gift = button.dataset.gift;
        let special = button.dataset.special;
        // button.disabled = true;

        console.log('cartLog: Delete Button', `
          key: ${key},
          index: ${index},
          variantId: ${variantId},
          customize: ${customize},
          quantity: ${quantity},
          gift: ${gift},
          special: ${special}
        `);

        if (Boolean(parseInt(customize)) && special == "false") { // Customize
          fetch("/cart.js")
            .then((response) => response.json())
            .then((cart) => {
              let lineItem = cart.items.find(
                (item) =>
                  item.product_id === 6618132021283 ||
                  item.product_id === 6822573211683 ||
                  item.product_id === 6618132054051
              );
              if (lineItem) {
                this.deleteItems({
                  updates: {
                    [lineItem.variant_id]: lineItem.quantity - quantity,
                    [key]: 0,
                  },
                });
              } else {
                this.deleteItems({
                  updates: {
                    [key]: 0,
                  },
                });
              }
            });
        } else if (gift === "true") {
          fetch("/cart.js")
            .then((response) => response.json())
            .then((cart) => {
              let giftLineItem = cart.items.find(
                (item) => item.product_id === 6767045214243
              );
              let giftProducts = cart.items.filter((item) => {
                return (
                  item.product_id != 6767045214243 &&
                  item.properties["Gift"] == "true"
                );
              });
              if (giftProducts.length == 1 && giftLineItem) {
                this.deleteItems({
                  updates: {
                    [giftLineItem.variant_id]: 0,
                    [key]: 0,
                  },
                });
              } else {
                this.deleteItem(key);
              }
            });
        } else {
          this.deleteItem(key);
        }
      });
    });
    this.openPackageModalButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.openPackageModal();
      });
    });
    this.giftButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        let key = button.dataset.key;
        let properties = JSON.parse(button.dataset.properties);
        this.toggleGift(key, properties);
        button
          .closest("[cart-item]")
          .querySelector("[delete-button]").dataset.gift = properties.gift;
      });
    });
    this.closePackageModalButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.closePackageModal();
      });
    });
  }

  updateCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        let cartData = data;
        this.cartCount.innerHTML = `(${data.item_count})`;
        this.cartCountHeader.innerHTML = `(${data.item_count})`;

        fetch("/cart?view=ajax-page")
          .then((res) => res.text())
          .then((data) => {
            let el = document.createElement("div");
            el.innerHTML = data;

            let cart_items = el.querySelector(".cart-items");
            var cart_summary = el.querySelector(".cart-summary");

            this.itemsContainer.innerHTML = cart_items.innerHTML;
            this.summaryContainer.innerHTML = cart_summary.innerHTML;

            this.deleteButtons = this.querySelectorAll("[delete-button]");
            this.giftButtons = this.querySelectorAll("[gift-input]");
            this.closePackageModalButtons = this.querySelectorAll(
              "[close-package-modal-button]"
            );
            this.openPackageModalButtons = this.querySelectorAll(
              "[gift-modal-trigger]"
            );
            this.bindEvents();
          });
      })
      .catch((error) => {
        console.log("change: ", error);
      });
  }

  deleteItem(line, quantity = 0) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: line, quantity: quantity }),
    })
      .then((response) => response.json())
      .then((data) => {
        let cartData = data;
        this.cartCount.innerHTML = `(${data.item_count})`;
        this.cartCountHeader.innerHTML = `(${data.item_count})`;
        fetch("/cart?view=ajax-page")
          .then((res) => res.text())
          .then((data) => {
            let el = document.createElement("div");
            el.innerHTML = data;

            let cart_items = el.querySelector(".cart-items");
            var cart_summary = el.querySelector(".cart-summary");

            this.itemsContainer.innerHTML = cart_items.innerHTML;
            this.summaryContainer.innerHTML = cart_summary.innerHTML;

            this.deleteButtons = this.querySelectorAll("[delete-button]");
            this.giftButtons = this.querySelectorAll("[gift-input]");
            this.closePackageModalButtons = this.querySelectorAll(
              "[close-package-modal-button]"
            );
            this.openPackageModalButtons = this.querySelectorAll(
              "[gift-modal-trigger]"
            );
            this.bindEvents();
            this.checkGiftFee(cartData);
          });
      })
      .catch((error) => {
        console.log("change: ", error);
      });
  }

  deleteItems(items) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(items),
    })
      .then((response) => response.json())
      .then((data) => {
        let cartData = data;
        this.cartCount.innerHTML = `(${data.item_count})`;
        this.cartCountHeader.innerHTML = `(${data.item_count})`;
        fetch("/cart?view=ajax-page")
          .then((res) => res.text())
          .then((data) => {
            let el = document.createElement("div");
            el.innerHTML = data;

            let cart_items = el.querySelector(".cart-items");
            var cart_summary = el.querySelector(".cart-summary");

            this.itemsContainer.innerHTML = cart_items.innerHTML;
            this.summaryContainer.innerHTML = cart_summary.innerHTML;

            this.deleteButtons = this.querySelectorAll("[delete-button]");
            this.giftButtons = this.querySelectorAll("[gift-input]");
            this.closePackageModalButtons = this.querySelectorAll(
              "[close-package-modal-button]"
            );
            this.openPackageModalButtons = this.querySelectorAll(
              "[gift-modal-trigger]"
            );
            this.bindEvents();
            this.checkGiftFee(cartData);
          });
      })
      .catch((error) => {
        console.log("change: ", error);
      });
  }

  toggleGift(line, properties) {
    let newProperties = {};

    properties.forEach((property) => {
      if (property[0] == "Gift") {
        property[1] = property[1] == "true" ? "false" : "true";
      }
      newProperties[property[0]] = property[1];
    });

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ line: line, properties: { ...newProperties } }),
    })
      .then((response) => response.json())
      .then((data) => {
        let cartData = data;
        this.cartCount.innerHTML = `(${data.item_count})`;
        this.cartCountHeader.innerHTML = `(${data.item_count})`;
        fetch("/cart?view=ajax-page")
          .then((res) => res.text())
          .then((data) => {
            let el = document.createElement("div");
            el.innerHTML = data;

            let cart_items = el.querySelector(".cart-items");
            var cart_summary = el.querySelector(".cart-summary");

            this.itemsContainer.innerHTML = cart_items.innerHTML;
            this.summaryContainer.innerHTML = cart_summary.innerHTML;

            this.deleteButtons = this.querySelectorAll("[delete-button]");
            this.giftButtons = this.querySelectorAll("[gift-input]");
            this.closePackageModalButtons = this.querySelectorAll(
              "[close-package-modal-button]"
            );
            this.openPackageModalButtons = this.querySelectorAll(
              "[gift-modal-trigger]"
            );
            this.bindEvents();
            this.checkGiftFee(cartData);
          });
      })
      .catch((error) => {
        console.log("change: ", error);
      });
  }

  checkGiftFee(cart) {
    let requiresGiftFee = false;
    let giftFee = false;
    let cartSubtotal = cart.total_price / 100 / Shopify.currency.rate;

    cart.items?.forEach((item) => {
      if (item.properties && item.properties["Gift"] == "true") {
        requiresGiftFee = true;
      }
      if (item.product_id == 6767045214243) {
        giftFee = true;
      }
    });

    if (requiresGiftFee && !giftFee && cartSubtotal < 2500 && !this.vipClient) {
      let formData = {
        items: [
          {
            quantity: 1,
            id: 39909133910051,
          },
        ],
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          fetch("/cart?view=ajax-page")
            .then((res) => res.text())
            .then((data) => {
              let el = document.createElement("div");
              el.innerHTML = data;

              let cart_items = el.querySelector(".cart-items");
              var cart_summary = el.querySelector(".cart-summary");

              this.itemsContainer.innerHTML = cart_items.innerHTML;
              this.summaryContainer.innerHTML = cart_summary.innerHTML;

              this.deleteButtons = this.querySelectorAll("[delete-button]");
              this.giftButtons = this.querySelectorAll("[gift-input]");
              this.closePackageModalButtons = this.querySelectorAll(
                "[close-package-modal-button]"
              );
              this.openPackageModalButtons = this.querySelectorAll(
                "[gift-modal-trigger]"
              );
              this.bindEvents();
            });
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      let giftLineItem = cart.items.find(
        (item) => item.product_id === 6767045214243
      );
      if (giftLineItem) {
        this.deleteItem(giftLineItem.key);
      }
    }
  }

  closePackageModal() {
    this.packageModal.classList.add("invisible");
  }

  openPackageModal() {
    this.packageModal.classList.remove("invisible");
  }
}

customElements.define("cart-drawer", CartDrawer);
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define("localization-form", LocalizationForm);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, 300)
        );
      }
    }
  );
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
